<template>
  <FormContainer withoutDivider>
    <template #title>Formation</template>
    <template #content>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_sousDispositif"
          v-model="sousDispositifModel"
          label="Sous dispositif"
          :required="meta.sousDispositif?.$status === PropertyStatus.Required"
          :alertLabel="meta.sousDispositif?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          :items="lov.SousDispositif"
          key-id="code"
          key-label="intitule"
          :readonly
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_160"
          v-model="referenceFormationInterneEntrepriseModel"
          label="Référence interne de l'entreprise"
          :required="meta.formation?.referenceFormationInterneEntreprise?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.referenceFormationInterneEntreprise?.$messageErreurDirty!"
          class="col-8 col-md-12 col-sm-36"
          hint="30 caractères maximum"
          help="Ce champ vous permet de renseigner une référence propre à votre entreprise"
          :maxlength="30"
          deletable
          :readonly
        />
        <WrapperInput
          v-if="meta.referenceProjet?.$status !== PropertyStatus.NotPresent && model?.sousDispositif !== 'AfFpe'"
          id="field_23"
          v-model="referenceProjetModel"
          label="Référence projet"
          :required="meta.referenceProjet?.$status === PropertyStatus.Required"
          :alertLabel="meta.referenceProjet?.$messageErreurDirty!"
          :maxlength="30"
          deletable
          class="col-18 col-md-18 col-sm-36"
          hint="30 caractères maximum"
          help="Si la formation est éligible à un cofinancement, merci d'indiquer la référence du projet"
          :readonly
        />
         <WrapperDropdown
          v-if="meta.formation?.referenceTypeProjet?.$status !== PropertyStatus.NotPresent && model?.sousDispositif === 'AfFpe'"
          id="field_23"
          v-model="referenceTypeProjetModel"
          label="Référence projet"
          :required="meta.formation?.referenceTypeProjet?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.referenceTypeProjet?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          :items="lov.ReferenceTypeProjet"
          key-id="code"
          key-label="intitule"
          :readonly
          help="Si la formation est éligible à un cofinancement, merci d'indiquer la référence du projet"
        />
        <WrapperDropdown
          v-if="meta.regionFtj?.$status !== PropertyStatus.NotPresent"
          id="field_regionFtj"
          v-model="regionFtjModel"
          label="Région FTJ"
          :required="meta.regionFtj?.$status === PropertyStatus.Required"
          :alertLabel="meta.regionFtj?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          :items="regionFtjItems"
          key-id="code"
          key-label="intitule"
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_10"
          v-model="objectifFormationModel"
          label="Objectif général de la formation"
          :required="meta.formation?.objectifFormation?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.objectifFormation?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          :items="objectifFormationItems"
          key-id="code"
          key-label="intitule"
          :readonly
          help="Cet élément décrit les objectifs généraux de la formation. Ils ne doivent pas être confondus avec les objectifs pédagogiques"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { FormContainer } from '@/features/interface/demande/shared'
  import { storeToRefs } from 'pinia'
  import { computed } from 'vue'

  const store = useDemandeAFStore()
  const { setupFieldWithKey } = store
  const { meta, lov, readonly, model } = storeToRefs(store)

  const sousDispositifModel = setupFieldWithKey<string>('sousDispositif')
  const objectifFormationModel = setupFieldWithKey<string>('formation.objectifFormation')
  const referenceFormationInterneEntrepriseModel = setupFieldWithKey<string>(
    'formation.referenceFormationInterneEntreprise',
    true,
  )
  const referenceProjetModel = setupFieldWithKey<string>('referenceProjet')
  // TODO attente specs pour ce champ
  const referenceTypeProjetModel = setupFieldWithKey<string>('formation.referenceTypeProjet')
  const regionFtjModel = setupFieldWithKey<string>('regionFtj')

  const regionFtjItems = computed(() => lov.value.RegionFtj.filter((item) => item.code !== 'NC'))

  const objectifFormationItems = computed(() => {
    if (model.value?.sousDispositif !== 'FTJ') return lov.value.ObjectifFormation
    const objectifFormationItemsFtj = ['DeveloppementCompetencesProfessionnelles', 'AdaptationMaintienEmploi', 'Reconversion']
    return lov.value.ObjectifFormation.filter((x) => objectifFormationItemsFtj.includes(x.code))
  })
</script>
